import { makeStyles } from 'tss-react/mui';
import { typographyTheme } from 'web-library/theme/helper/tssHelper';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) => ({
  // main CSS for each element
  formElementContainer: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
    width: '100%',
  },
  halfWidthLeftItem: {
    width: '50%',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: 0,
    },
  },
  halfWidthRightItem: {
    width: '50%',
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingLeft: 0,
    },
  },
  groupFormElementContainer: {
    marginBottom: theme.spacing(1),
    width: '100%',
  },
  groupHalfWidthLeftItem: {
    width: '50%',
    paddingRight: 4,
  },
  groupHalfWidthRightItem: {
    width: '50%',
    paddingLeft: 4,
  },

  // other CSS
  mainContainer: {
    width: '100%',
    marginBottom: theme.spacing(7),
  },
  responsiveFlexContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    maxWidth: '1650px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  form: {
    width: '90%',
  },
  formHeader: {
    width: '100%',
  },
  groupMultirowContainer: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  groupSingleRowContainer: {
    display: 'flex',
    displayDirection: 'row',
    width: '100%',
  },
  submitButton: {
    width: '100%',
  },
  label: { ...typographyTheme(theme, 'subtitle2') },
  groupOfInputsLabel: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  preferredLabel: {
    marginLeft: theme.spacing(2),
    display: 'inline',
  },
  extraInfoText: {
    color: theme.color.text.textSecondary,
    marginBottom: theme.spacing(2),
  },
  submitButtonContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  formControl: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  requiredLabel: {
    color: theme.color.state.stateImportant,
    marginLeft: theme.spacing(0.5),
    display: 'inline',
  },
  disabled: {
    color: theme.color.text.textDisabled,
  },
  disabledLabel: {
    color: theme.color.text.textDisabled,
    marginLeft: theme.spacing(0.5),
    display: 'inline',
  },
  helperText: {
    color: theme.color.text.textHeader,
    fontWeight: 400,
    marginBottom: theme.spacing(0.5),
  },
  nricFin: {
    // CPEPOKPNEH-2662 - Defined custom breakpoint value to ensure that the IdField and nricField are vertically aligned.

    [theme.breakpoints.between('sm', 768)]: {
      marginTop: theme.spacing(6),
    },
    [theme.breakpoints.between(768, 820)]: {
      marginTop: theme.spacing(17),
    },
    [theme.breakpoints.between(820, 1024)]: {
      marginTop: theme.spacing(14),
    },
    [theme.breakpoints.between(1024, 1118)]: {
      marginTop: theme.spacing(11),
    },
    [theme.breakpoints.between(1118, 1184)]: {
      marginTop: theme.spacing(15),
    },
    [theme.breakpoints.up(1184)]: {
      marginTop: theme.spacing(9),
    },
  },
  requestForAmendmentButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginBottom: theme.spacing(2),
    },
  },
  requestForAmendmentText: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  requestForAmendmentButton: {
    height: 'fit-content',
  },
  retrieveMyInfoWithSingpass: {
    padding: '0 !important',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(5),
  },
  getAddressButton: {
    width: 'calc(100% - 166px)',
    paddingRight: theme.spacing(1),
    display: 'inline-flex',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      paddingRight: theme.spacing(0),
      paddingBottom: theme.spacing(1),
    },
  },
}));
